export enum PermissionLevel {
  SystemAdmin = 1,     // מנהל מערכת
  SalesRep = 2,        // נציג מכירות
  CaseManager = 3,     // מנהל תיקים
  Secretary = 4,       // מזכירה
  TenantAdmin = 5      // מנהל הגדרות
}

export const PermissionLevelNames: Record<PermissionLevel, string> = {
  [PermissionLevel.SystemAdmin]: 'מנהל מערכת',
  [PermissionLevel.SalesRep]: 'נציג מכירות',
  [PermissionLevel.CaseManager]: 'מנהל תיקים',
  [PermissionLevel.Secretary]: 'מזכירה',
  [PermissionLevel.TenantAdmin]: 'מנהל הגדרות'
};

export interface UserPermissions {
  permissionLevel: PermissionLevel;
  isSupervisor: boolean;
  hasPermission: (requiredPermissions: PermissionLevel[]) => boolean;
}

export const createUserPermissions = (permissionLevel: PermissionLevel, isSupervisor: boolean = false): UserPermissions => ({
  permissionLevel,
  isSupervisor,
  hasPermission: (requiredPermissions: PermissionLevel[]) => 
    requiredPermissions.includes(permissionLevel)
});